<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <WorkgroupListing />

    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import WorkgroupListing from "@/views/pages/admin/workgroup/workgroupListing";

export default {
    page: {
        title: i18n.t("module.workgroup"),
    },
    components: { Layout, PageHeader, WorkgroupListing },
    data() {
        return {
            title: i18n.t("module.workgroup"),
            items: [
                {
                    text: i18n.t("module.orientation"),
                    href: '/orientations',
                },
                {
                    text: i18n.t("module.workgroup"),
                    active: true,
                },
            ],
        };
    },
}
</script>
